<template>
	<div class="gap-3 tw-flex">
        <AppButton
            :label="$t('contacts.manage-groups')"
            variant="gray"
            secondary
            size="md"
            @click="redirectToList()"
        />

		<div>
            <AppMenu @open="isMenuOpened = true" @close="isMenuOpened = false">
                <template #trigger>
                    <AppButton
                        startIcon="assets/v2/image/icons/plus.svg"
                        :label="$t('contacts.add-contacts')"
                        variant="brand"
                        size="md"
                    />
                </template>
                <div
                    class="menu-item m-3 mb-0 tw-cursor-pointer"
                    @click="contactStore.isOpenContactDialog = true"
                >
                    <span>{{ $t('contacts.single-contact') }}</span>
                </div>
                <div
                    class="menu-item m-3 tw-cursor-pointer"
                    @click="contactStore.isOpenUploadContactsDialog = true"
                >
                    <p>{{ $t('contacts.upload-csv') }}</p>
                </div>
            </AppMenu>
        </div>
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import AppMenu from '@/v2/components/app-menu';
import { ref } from 'vue';
import { useContactStore } from '@/v2/modules/contacts/stores/contacts';

const router = useRouter();
const isMenuOpened = ref(false);
const contactStore = useContactStore();

const redirectToList = () => {
	router.push({ name: 'contacts-group' });
};
</script>

<style lang="scss" scoped></style>
